import { Location } from "../models/location";

export class SortLocationsByNameValueConverter {
	toView(array: Array<Location>): Array<Location> {
		if (array === undefined || array === null) {
			return null;
		}
		return [...array].sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true }));
	}
}